export function CardsWrapper(props: { children: JSX.Element | JSX.Element[], css?: any }) {
    return <div className="CardsWrapper" style={props.css}>
        {props.children}
    </div>
}